import { Component, OnInit, OnDestroy, inject, signal, computed } from '@angular/core';
import { SidebarService } from '../../services/sidebar.service';
import { ElevatorStateService } from '../../services/elevator-state.service';
import { ThemeService } from '../../services/theme.service';
import { MapTourService } from '../../services/map-tour.service';
import { MapSoundService } from '../../services/map-sound.service';
import { Subscription, interval } from 'rxjs';

@Component({
  selector: 'app-header',
  imports: [],
  templateUrl: './header.html',
  styleUrl: './header.scss'
})
export class HeaderComponent implements OnInit, OnDestroy {
  protected sidebarService = inject(SidebarService);
  private stateService = inject(ElevatorStateService);
  protected themeService = inject(ThemeService);
  protected mapTourService = inject(MapTourService);
  protected mapSoundService = inject(MapSoundService);
  private timerSub?: Subscription;

  protected readonly timeString = signal('');

  // Map to store signals using computed for template compatibility
  protected readonly activeAlerts = computed(() => this.stateService.activeAlerts().length);
  protected readonly totalElevators = computed(() => this.stateService.totalCount());
  protected readonly runningElevators = computed(() => this.stateService.runningCount());
  protected readonly idleElevators = computed(() => this.stateService.idleCount());
  protected readonly errorElevators = computed(() => this.stateService.errorCount());
  protected readonly maintenanceElevators = computed(() => this.stateService.maintenanceCount());

  ngOnInit() {
    // 1. Clock timer
    this.updateTime();
    this.timerSub = interval(1000).subscribe(() => this.updateTime());
  }

  ngOnDestroy() {
    this.timerSub?.unsubscribe();
  }

  private updateTime() {
    const now = new Date();
    this.timeString.set(now.toLocaleTimeString('en-US', { hour12: false }));
  }
}

